import { Input } from 'components/UI/V3/Forms/Input/Input';
import { Label } from 'components/UI/V3/Forms/Label/Label';
import CounterField from 'components/UI/V3/CounterField/CounterField';
import { ChangeEvent, FunctionComponent } from 'react';
import styles from './BasicInfoSection.module.scss';

interface BasicInfoSectionProps {
    name: string;
    maxPets: number;
    nameError: string | null;
    onChange?: (name: string, maxPets: number) => void;
}

export const BasicInfoSection: FunctionComponent<BasicInfoSectionProps> = props => {
    const changeNameHandler = (event: ChangeEvent<HTMLInputElement>) => {
        props.onChange?.(event.target.value, props.maxPets);
    };

    const changeMaxPetsHandler = (value: number) => {
        props.onChange?.(props.name, value);
    };

    return (
        <div className={styles.container}>
            <Input
                label="Vehicle Name"
                required={true}
                value={props.name}
                error={props.nameError}
                onChange={changeNameHandler}
                placeholder="e.g., Blue Van, White SUV"
            />
            <div className={styles.maxPetsWrapper}>
                <Label className={styles.maxPetsLabel}>Max # of Pets</Label>
                <CounterField
                    value={props.maxPets}
                    onChange={changeMaxPetsHandler}
                    minLimit={1}
                    maxLimit={999}
                    hasBorder={true}
                    className={styles.counter}
                />
            </div>
        </div>
    );
};

export default BasicInfoSection;
